import { render, staticRenderFns } from "./_solarsystem.svg.vue?vue&type=template&id=635ea134&"
import script from "./_solarsystem.svg.vue?vue&type=script&lang=js&"
export * from "./_solarsystem.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports